import ClassenService from '../ClassenService';

class SelectionService {
  getSelections() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/selections`);
  }

  getSelectionSuggestions() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/selections/suggestions`);
  }

  addSelection(selectionData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/selections`, 'addSelection', selectionData);
  }

  getHRImages(selectionId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/selections/${selectionId}/hrimages`);
  }

  requestImages(selectionData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/selections/${selectionData.selectionId}/request`, 'request images', selectionData);
  }

  generateExcel(selectionData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/selections/${selectionData.selectionId}/export/excel`, 'generate excel', selectionData)
  }

  getGenerateExcelStatus(selectionData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/selections/${selectionData.selectionId}/export/excel/status`, 'get generate excel status', selectionData)
  }

  uploadSelectionLogo(data) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/selections/uploadLogo`, 'uploadSelectionLogo', data);
  }

  getSelection(selectionId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/selections/${selectionId}`);
  }

  getSelectionItems(selectionId, page) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/selections/${selectionId}/items?page=${page}`);
  }

  duplicateSelection(selectionId) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/selections/${selectionId}/duplicate`);
  }

  updateSelection(selectionId, selectionData) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/selections/${selectionId}`, 'updateSelection', selectionData);
  }

  deleteSelection(selectionId) {
    return ClassenService.doApiCall('delete', `${process.env.VUE_APP_API}/selections/${selectionId}`, 'deleteSelection');
  }

  deleteSelectionItem(selectionItemId) {
    return ClassenService.doApiCall('delete', `${process.env.VUE_APP_API}/selections/items/${selectionItemId}`, 'deleteSelectionItem');
  }

  addProductToSelection(selectionId, productId) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/selections/${selectionId}/products/${productId}`, 'addProductToSelection');
  }

  addDecorToSelection(selectionId, decorId) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/selections/${selectionId}/decors/${decorId}`, 'addDecorToSelection');
  }

  removeProductFromSelection(selectionId, productId) {
    return ClassenService.doApiCall('delete', `${process.env.VUE_APP_API}/selections/${selectionId}/products/${productId}`, 'removeProductFromSelection');
  }

  removeDecorFromSelection(selectionId, decorId) {
    return ClassenService.doApiCall('delete', `${process.env.VUE_APP_API}/selections/${selectionId}/decors/${decorId}`, 'removeDecorFromSelection');
  }

  generateSelectionPdf(selectionData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/selections/${selectionData.selectionId}/export/pdf`, 'generate pdf', selectionData.data);
  }

  getGenerateSelectionPdfStatus(selectionData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/selections/${selectionData.selectionId}/export/pdf/status`, 'get generate pdf status', selectionData);
  }

  generateLink(selectionId, selectionData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/selections/${selectionId}/export/link`, 'generate export link', selectionData);
  }

  getSharedSelection(selectionId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/selections/external/${selectionId}`, 'get shared selection');
  }

  getSharedSelectionItems(selectionId, page) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/selections/external/${selectionId}/items?page=${page}`, 'get shared selection items');
  }

  getSharedSelectionLanguages() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/selections/external/languages`);
  }

  getInformationForSharedSelection(selectionId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/selections/external/${selectionId}/information`, 'get selected information options for shared selection');
  }

  getProductForSharedSelection(selectionId, productId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/selections/external/${selectionId}/products/${productId}?sharedSelectionId=${selectionId}`, 'get product from shared selection');
  }

  getDecorForSharedSelection(selectionId, decorId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/selections/external/${selectionId}/decors/${decorId}?sharedSelectionId=${selectionId}`, 'get decor from shared selection');
  }

  /* Selection list* */
  getSelectionLists(selectionId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/selection/${selectionId}/lists`);
  }

  addSelectionList(selectionId, selectionListData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/selection/${selectionId}/lists`, 'addSelectionList', selectionListData);
  }

  getSelectionList(selectionId, selectionListId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/selection/${selectionId}/lists/${selectionListId}`);
  }

  updateSelectionList(selectionId, selectionListId, selectionListData) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/selection/${selectionId}/lists/${selectionListId}`, 'updateSelectionlist', selectionListData);
  }

  deleteSelectionList(selectionId, selectionListId) {
    return ClassenService.doApiCall('delete', `${process.env.VUE_APP_API}/selection/${selectionId}/lists/${selectionListId}`, 'deleteSelectionList');
  }

  /* --Selection-list-item--* */
  getSelectionListItems(selectionListId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/selection/list/${selectionListId}/items`);
  }

  addSelectionListItem(selectionListId, selectionListItemData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/selection/list/${selectionListId}/items`, 'addSelectionListItem', selectionListItemData);
  }

  getSelectionListItem(selectionListId, selectionListItemId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/selection/list/${selectionListId}/items${selectionListItemId}`);
  }

  updateSelectionListItem(selectionListId, selectionListItemId, selectionListItemData) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/selection/list/${selectionListId}/items${selectionListItemId}`, 'updateSelectionlistItem', selectionListItemData);
  }

  deleteSelectionListItem(selectionListId, selectionListItemId) {
    return ClassenService.doApiCall('delete', `${process.env.VUE_APP_API}/selection/lists/${selectionListId}/items/${selectionListItemId}`, 'deleteSelectionListItem');
  }
}

export default new SelectionService();
